import * as THREE from 'three'
require('three-orbitcontrols');

import printModel from '../../../3dapps/mixins/printModel';
import { initThree, camera, renderer, currentGroup, updateMesh, incRenderCount, updateColorMode } from './initThree'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Range from 'vux/src/components/range/index.vue'

import { SourceExporter } from './SourceExporter'
import { baseURL } from '@/request/request.js';
import loading from '@/components/loading';




function image2Base64(img) {
var canvas = document.createElement("canvas");
canvas.width = img.width;
canvas.height = img.height;
var ctx = canvas.getContext("2d");
ctx.drawImage(img, 0, 0, img.width, img.height);
var dataURL = canvas.toDataURL("image/jpg");
return dataURL;
}

let imgurl;
let imgUid;
let originWidth = 200; 
let currentbeautifyIndex;

function formateDate(date) {
return date.getFullYear() + "."
+ (date.getMonth() + 1).toString().padStart(2, "0") + "."
+ date.getDate().toString().padStart(2, "0");
}

const contextList = [
"每天都要元气满满哦", "祝你生日快乐", "快乐工作,快乐生活", "每天进步一点点"
]

const sampleImageUids = [
"sample,9a15e9fd6b0a4363926446a9a18be6f3",
"sample,febbec1995c94a3f8c1e7cf3229db14a",
"sample,bd5497c92f034ffc8f1a51f030950875",
"sample,ef2a9afc345f4804b67e6750408e75cf",
"sample,cd4302e9dcfd4ffa8af56d05b24f70e0",
"sample,935c758473a94ea288f0709c813055d5",
"sample,8cbed45f48954a6d942f9548ef57041f",
"sample,54bf14eb23414ad3bb5240ab73cfbfd4",
"sample,d91bdf2db495486f833d172cb3f75ebd",
"sample,354be159fd9e4ae3a3b4e80cef38a76d",
"sample,090ccdf08584441b9d3bbc65fcdf4c9c",
"sample,7ec2b0ba10684bb49e375536bd5d1f1f",
"sample,a1caf27741f04bf1970c2a92e5472173",
"sample,e128d2beb38c45d2b3a5aecddb793a41",
"sample,a79ea760d873497b861c6e4cf623b897",
"sample,e194dc126bc649afa8aa6efe54b776b9",
"sample,dae71371b786403a9db9c9b27467bbc5",
"sample,7e46627141f445698e9069ac33088523",
"sample,fde1e6c1f8584629a171a4f0def185ea",
"sample,bd53459cb3e84aa59b59973e86d1a08e"
];

let userUploadImageUids = [];

function makeImageUrl(uid, process, ext) {
return baseURL + '/makeRelief/getImage/' + uid + '/' + process + ext;
}


export default {
name: "relief",
mixins: [printModel],
components: {
Group,
XDialog,
Actionsheet,
Grid, GridItem, XNumber, XInput, Popup, Radio, Flexbox, FlexboxItem,
Toast, XSwitch, Tab, TabItem, Checker, CheckerItem, Range, loading
},

data() {
return {
classA: true,
quotationName: "浮雕相框",
productType: "浮雕相框",
landscape: true,//竖屏状态要一直为true
tabTitle: [
{
title: '文本'
}, {
title: '美化'
}, {
title: '图片'
},
],
cur: 0, //默认选中第一个tab
showLoading: false,
colorfulMaterialIndex: -1,
plainMaterialIndex: -1,
draw: {
imageWidth: 800,//手机端显示用800，后台不同，用1000
image: imgurl,
width: 120,//宽高比
height2: 152, // 浮雕高度
height: 2,//浮雕厚度
thickness: 1,//打底厚度
blur: 2,//模糊
useText: true,
text: contextList[Math.floor(Math.random() * contextList.length)],
fontSize: 60,
reverse: false,
flower: false, // 暂时不要花纹
colorful: true, // 彩色
effect: "origin",
},
addCartIndex: -1,
orderIndex: -1,
isShapeIndex: 0,
userUploadImages: [],
showPrint: false,
color: "#B0B7BA",
modelSplit: false,
ShapeList: [],
showBeautify: false,
showColor: false,
showText: false,
n: 0,
text: 1,
textModel: true,
isreliefBtnIndex: -1,//顶部按钮默认
btnsListIndex: -1,//顶部按钮下标
btnsList: [
{
isClick: false,
icon: require("../../../3dapps/imgs/拍照.png"),
iconClick: require("../../../3dapps/imgs/拍照-选中.png"),
title: "拍照",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/相册.png"),
iconClick: require("../../../3dapps/imgs/相册-选中.png"),
title: "相册",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/编辑.png"),
iconClick: require("../../../3dapps/imgs/编辑-选中.png"),
title: "编辑",
},
{
isClick: false,
icon: require("../../../3dapps/imgs/尺寸.png"),
iconClick: require("../../../3dapps/imgs/尺寸-选中.png"),
title: "规格",
},

], //按钮列表
sampleImages: sampleImageUids.map(uid => makeImageUrl(uid, 'thumb', '.jpg')),
beautifyIndex: 0,//初始值-美化
beautifyList: [{
effect: "origin",
title: "原图"
}, {
effect: "charcoal",
title: "碳画"
}, {
effect: "negate",
title: "反相"
}, {
effect: "image-seg",
title: "去背景"
}, {
effect: "monochrome",
title: "沙画"
}, {
effect: "kuwahara",
title: "油画"
}, {
effect: "spread",
title: "磨砂"
}, {
effect: "edge",
title: "线条"
}, {
effect: 'anime',
title: '人物动漫化'
}],
drawText: "",//储存文本
showOnText: true, //是否显示文本框
specsList: [
{
width: 128,
height: 178,
value: '128x178'
},
{
width: 154,
height: 204,
value: '154x204'
},
{
width: 178,
height: 228,
value: '178x228'
},
{
width: 228,
height: 278,
value: '228x278'
}
],//规格列表
thicknessList: [
{
id: '1',
thickness: 2,
value: '2mm'
}, {
id: '2',
thickness: 3,
value: '3mm'
}, {
id: '3',
thickness: 4,
value: '4mm'
},
],
showCartoondolls: true,//价格弹窗
isSpecsBtnIndex: 0,//初始值-浮雕尺寸
isSpecsBtnIndexTemp: 0,
isthicknessIndex: 0,//初始值-浮雕厚度
isthicknessIndexTemp: 0,
}
},
mounted() {

const scope = this;
scope.showLoading = true;


var mo = function (e) {
e.preventDefault();
}


var tabList = this.$refs.tabList; 

var screenHeight = window.innerHeight;
window.onresize = function () {
var height = document.documentElement.clientHeight;

if (screenHeight !== window.innerHeight) {

tabList.style.bottom = 0 + "px";
tabList.style.position = "absolute";
} else {

tabList.style.bottom = 50 + "px";
tabList.style.position = "fixed";
}
};
window.addEventListener("resize", onresize);


var interval;


tabList.onfocus = function () {
interval = setInterval(function () {
tabList.style.bottom = 0 + "px";
tabList.style.position = "absolute";
}, 500)
};


tabList.onblur = function () {
tabList.style.bottom = 50 + "px";
tabList.style.position = "fixed";
clearInterval(interval);
};


scope.$nextTick(function () {
scope.$refs.relief.style.paddingTop = '0px';
scope.$refs.relief.style.overflow = 'hidden';
scope.$refs.canvasBox.addEventListener("touchmove", mo, false);
});

initThree(scope.$refs.canvas);


const contentDOM = scope.$refs.relief;


const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);





this.$nextTick(function () {
this.loadData();
if (this.draw.colorful) {
this.draw.colorful = true;
} else {
this.draw.colorful = false;
}
});

},
methods: {

isClickSize(index, item) {
this.isSpecsBtnIndexTemp = index;

},


isClickThickness(index) {
this.isthicknessIndexTemp = index;

},


isSure() {
this.btnsListIndex = -1;
this.isTopBtn1();

this.showLoading = true;

const scope = this;
setTimeout(function () {
scope.isSpecsBtnIndex = scope.isSpecsBtnIndexTemp;
scope.isthicknessIndex = scope.isthicknessIndexTemp;
scope.draw.width = scope.specsList[scope.isSpecsBtnIndex].width;
scope.draw.height2 = scope.specsList[scope.isSpecsBtnIndex].height;
scope.draw.height = scope.thicknessList[scope.isthicknessIndex].thickness;
updateMesh(scope.draw);
scope.showLoading = false;
scope.updatePriceOnChangeLocal();
}, 50);
},


canelPop() {
this.isSpecsBtnIndexTemp = this.isSpecsBtnIndex;
this.isthicknessIndexTemp = this.isthicknessIndex;

this.btnsListIndex = -1;
this.isTopBtn1();
},


isShowPrintPrice() {
const scope = this;
scope.showLoading = true;
setTimeout(function () {
scope.draw.colorful = !scope.draw.colorful;
updateColorMode(scope.draw);
scope.touchstart();
scope.showLoading = false;
}, 50);
},

isTopBtn0() {
if (!this.isClick) {
this.isreliefBtnIndex = -1;
this.btnsList[2].isClick = false;
}
},

isTopBtn1() {
if (!this.isClick) {
this.isreliefBtnIndex = -1;
this.btnsList[3].isClick = false;
}
},


handler(index) {
let btnsListIndex = this.btnsListIndex;


if (btnsListIndex === index) {
this.btnsList[index].isClick = !this.btnsList[index].isClick;
this.btnsListIndex = -1;
} else {
this.btnsList[index].isClick = true;
this.btnsListIndex = index;

if (btnsListIndex !== -1) {
this.btnsList[btnsListIndex].isClick = false;
}
}

if (index === 0 || index === 1) {
this.showCartoondolls = true;

if (index === 0) {
this.btnsList[0].isClick = false;
this.selectFile2();
} else {
this.btnsList[1].isClick = false;
this.selectFile1();
}
}

if (index === 2) {

let scale = this.draw.width / originWidth;
currentGroup.scale.set(scale, scale, scale);

let isclick = this.btnsList[2].isClick;
if (isclick) {
this.$set(this.tabTitle[this.cur], `isClick`, !isclick);
}
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.showCartoondolls = btnsListIndex === 2 ? true : false;
}


if (btnsListIndex === 2) {
this.beautifyIndex = 0;
}

this.resize();
},


resize() {
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
if (this.btnsListIndex == 2) {
let tabHeight = h * 0.2;
h = h - tabHeight;
}
camera.aspect = w / h;
camera.updateProjectionMatrix();
renderer.setSize(w, h);
incRenderCount();
},

exporter() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(currentGroup, {
binary: true
});
let blob = new Blob([result], {
type: 'application/octet-stream'
});

let filename = "model.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},


selectFile1() {
this.btnsListIndex = -1;

this.$refs.btn_import1.click();
},

selectFile2() {
this.btnsListIndex = -1;

this.$refs.btn_import2.click();
},


selectBeautify() {
this.showText = false;
this.showBeautify = true;
},


onsmoothsItemClick(index, effect) {
const scope = this;
let ext;
scope.beautifyIndex = index;
scope.draw.effect = effect;
currentbeautifyIndex = scope.beautifyIndex;


this.showLoading = true;

if (scope.isShapeIndex >= 0) {
imgUid = sampleImageUids[scope.isShapeIndex];
ext = ".jpg";
} else {
imgUid = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].uid;
ext = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].ext;
}
let src = baseURL + "/makeRelief/getImage/" + imgUid + "/" + this.draw.effect + ext;

let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.updatePriceOnChangeLocal();
scope.showLoading = false;
};
img.src = src;

},



selectText() {
this.btnsListIndex = 2;
this.showText = true;
this.showBeautify = false;
},


onTextClick() {
const scope = this;
scope.showLoading = true;
setTimeout(function () {
updateMesh(scope.draw);
scope.updatePriceOnChangeLocal();
scope.showLoading = false;
}, 50);
},


ontextSure() {
const scope = this;
scope.showLoading = true;
var textValue = scope.$refs.getValue.value;
setTimeout(function () {
if (textValue == "") {
scope.$vux.toast.show({
text: '文本不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
scope.$refs.getValue.value = scope.draw.text;
return;
}
else {
scope.textModel = true;
scope.draw.text = textValue;
}
updateMesh(scope.draw);
scope.updatePriceOnChangeLocal();
scope.showLoading = false;
}, 50);
},


seleShapeItem(index) {
const scope = this;
scope.isShapeIndex = index;
scope.showLoading = true;
scope.beautifyIndex = 0;

if (scope.isShapeIndex >= 0) {//预设图片
let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.updatePriceOnChangeLocal();
scope.showLoading = false;
scope.beautifyIndex = currentbeautifyIndex;
};
img.src = makeImageUrl(sampleImageUids[scope.isShapeIndex], this.draw.effect, '.jpg');
} else {

scope.draw.image = scope.$refs['img2-' + (scope.isShapeIndex + scope.userUploadImages.length)][0];
scope.beautifyIndex = 0;
updateMesh(scope.draw);
scope.updatePriceOnChangeLocal();
scope.showLoading = false;
}
},

makeStlBlob() {
let sourceExporter = new SourceExporter();
let sourceBlob = sourceExporter.makeBlob(this.draw);
return sourceBlob;
},

getUploadUrl() {
return "/makeRelief2/makeModel";
},

onFileChange1(e) {
let file = e.target.files[0];
if (!file) {
return;
};



if (file.type == "text/plain") {
this.$vux.toast.show({
text: '只能上传图片，图片格式必须为JPG格式',
type: "warn",
time: 2000,
position: "middle",
});
return;
} else {

let formData = new FormData();
formData.append("img", file);
this.$request.post("/makeRelief/addImage", formData, {
headers: {
'Content-Type': 'multipart/form-data'
}
}).then(res => {

userUploadImageUids.unshift({
uid: res.obj.img_uid,
ext: res.obj.ext
});
});
let url = URL.createObjectURL(file);
this.userUploadImages.unshift(url);
this.isShapeIndex = -this.userUploadImages.length;

this.showLoading = true;
const scope = this;
let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.updatePriceOnChangeLocal();
scope.showLoading = false;
};
img.src = url;
}
},
getModelToPrint() {
return currentGroup;
},


touchstart() {
this.btnsListIndex = -1;
this.isreliefBtnIndex = -1;
this.btnsList[2].isClick = false;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.btnsList[3].isClick = false;
this.showCartoondolls = true;
this.resize();
},


saveData() {
if (window.localStorage) {
let data = {};
data.width = this.draw.width;
data.height2 = this.draw.height2;
data.height = this.draw.height;
data.useText = this.draw.useText;
data.text = this.draw.text;
data.colorful = this.draw.colorful;
data.isShapeIndex = this.isShapeIndex;
data.isSpecsBtnIndex = this.isSpecsBtnIndex;
data.isthicknessIndex = this.isthicknessIndex;
data.effect = this.draw.effect;
data.beautifyIndex = this.beautifyIndex;
data.userUploadImages = this.userUploadImages;
localStorage.setItem("relief3d2", JSON.stringify(data));
}
},


loadData() {
const scope = this;

if (window.localStorage) {
let dataStr = localStorage.getItem("relief3d2");

localStorage.removeItem("relief3d2"); 
if (dataStr) {
let data = JSON.parse(dataStr);
this.draw.width = data.width;
this.draw.height2 = data.height2;
this.isShapeIndex = data.isShapeIndex;
this.draw.effect = data.effect;
this.draw.useText = data.useText;
this.draw.text = data.text;
this.draw.colorful = data.colorful;
this.beautifyIndex = data.beautifyIndex;
this.userUploadImages = data.userUploadImages;
this.isSpecsBtnIndex = data.isSpecsBtnIndex;
this.isthicknessIndex = data.isthicknessIndex;
this.isSpecsBtnIndexTemp = this.isSpecsBtnIndex;
this.isthicknessIndexTemp = this.isthicknessIndex;


this.showLoading = true;

let ext;
if (this.isShapeIndex >= 0) {
imgUid = sampleImageUids[scope.isShapeIndex];
ext = ".jpg";
} else {
imgUid = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].uid;
ext = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].ext;
}
let src = baseURL + "/makeRelief/getImage/" + imgUid + "/" + this.draw.effect + ext;

let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.updatePriceOnChangeLocal();
updateColorMode(scope.draw);
scope.showLoading = false;
};
img.src = src;
return;
}
}

let image = new Image();

console.time("first load");
image.crossOrigin = "anonymous";
image.onload = function () {
scope.draw.image = image;
console.time("update mesh");
updateMesh(scope.draw);
scope.updatePriceOnChangeLocal();
console.timeEnd("update mesh");
scope.showLoading = false;
console.timeEnd("first load");
};
image.src = makeImageUrl(sampleImageUids[0], this.draw.effect, '.jpg');
},

onMaterialLoaded() {
this.plainMaterialIndex = this.printMaterials.findIndex(m => m.materialName === "光敏树脂GenL (SLA)");
if (this.plainMaterialIndex < 0) this.plainMaterialIndex = 0;
this.colorfulMaterialIndex = this.printMaterials.findIndex(m => m.materialName === "全彩光敏树脂 (SLA)");
if (this.colorfulMaterialIndex < 0) this.colorfulMaterialIndex = 1;

this.printMaterialIndex = this.colorfulMaterialIndex;
this.updatePriceOnChangeLocal();
},


print() {

this.modelSplit = true;
this.showLoading = true;



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;

}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;

}

if (currentGroup) {















this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
const scope = this;
this.getPrice();
scope.showLoading = false;
});

} else {
this.$vux.toast.show({
text: '3D浮雕不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.refresh3d();
this.showLoading = false;
}
},
},
watch: {
"draw.colorful": function () {
updateColorMode(this.draw);
this.printMaterialIndex = this.draw.colorful ? this.colorfulMaterialIndex : this.plainMaterialIndex;
this.updatePriceOnChangeLocal();
},
},
}


// WEBPACK FOOTER //
// ./src/views/reliefPhoto/scripts/reliefPhoto.js